import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { ClientFeaturePermission } from '../../../admin/users/store/types';
import { getClientHasFeaturePermission } from '../../../auth/login/store/selectors';
import { getDocumentNettingAnalysisModalOpen, toggleDocumentNettingAnalysisModal } from '../../../documents/my-documents/store';
import { ArkDocument } from '../../../documents/store/types';
import { getIsCalculatingResults, getNettingEngineResults } from '../../../opinions/netting-engine/store/selectors';
import { ResultsModal } from './ResultsModal';
import { SummaryModal } from './SummaryModal';

interface DocumentNettingAnalysisProps {
    originalDocument: ArkDocument;
}

export const DocumentNettingAnalysis: React.FC<DocumentNettingAnalysisProps> = ({ originalDocument }) => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(getDocumentNettingAnalysisModalOpen);
    const hasOpinionModulePermission = useAppSelector(getClientHasFeaturePermission([ClientFeaturePermission.OPINION_MODULE]));
    const isCalculatingResults = useAppSelector(getIsCalculatingResults);
    const nettingResults = useAppSelector(getNettingEngineResults);

    const closeModal = useCallback(() => dispatch(toggleDocumentNettingAnalysisModal(false)), [dispatch]);

    const resultsShown = useMemo(() => !isNull(nettingResults) || isCalculatingResults, [nettingResults, isCalculatingResults]);

    if (!isOpen || !hasOpinionModulePermission) {
        return null;
    }

    if (resultsShown) {
        return (
            <ResultsModal isOpen closeModal={closeModal} nettingResults={nettingResults} isCalculatingResults={isCalculatingResults} />
        );
    }

    return (
        <SummaryModal closeModal={closeModal} isOpen originalDocument={originalDocument} />
    );
};
